import React from "react";
import { Select } from "antd";
import find from 'lodash/find';
import partners from "./partners.json";
import classNames from "classnames";
import css from "./Report.module.css"; 

const CUSTOMER_ID = "SD CUSTOMERS distro serial" ;
const CUSTOMER_LABEL = "Customer Name";

export const Partners = ({ value, onChange, ...restProps }) => {
  let options = partners.map(p => ({
    label: p[CUSTOMER_LABEL],
    value: p[CUSTOMER_ID] 
  }));
  
  options.sort((a, b) => {
      let nameA = a.label.toUpperCase(); // ignore upper and lowercase
      let nameB = b.label.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
          return -1;
      }
      if (nameA > nameB) {
          return 1;
      }
  
      // names must be equal
      return 0; 
  });

  const handleSelectChange = (selectedValue) => {
    // 1. Find the full partner row from your source array
   let fullPartner = find(partners, p => p[CUSTOMER_ID] === selectedValue);

    // 2. Pass the full partner entry up to the AntD Form state
    if (onChange) {
      onChange(fullPartner);
    }
  };

  // 3. Extract just the scalar ID to keep the Select component happy.
  const selectValue = value && value[CUSTOMER_ID] !== undefined ? value[CUSTOMER_ID] : value;

  return (
    <Select
      {...restProps} // Passes down status, placeholder, allowClear, etc.
      allowClear
      placeholder="Partner"
      options={options}
      value={selectValue}
      onChange={handleSelectChange}
      showSearch={true}
      optionFilterProp="label"    
    />
  );
};